import photo1 from "../assets/photo1.webp";
import photo2 from "../assets/photo2.webp";
import photo3 from "../assets/photo3.webp";
import photo4 from "../assets/photo4.webp";
import photo5 from "../assets/photo5.webp";
import photo6 from "../assets/photo6.webp";
import photo7 from "../assets/photo7.webp";
import photo8 from "../assets/photo8.webp";
import photo9 from "../assets/photo9.webp";
import photo10 from "../assets/photo10.webp";
import photo11 from "../assets/photo11.webp";
import photo12 from "../assets/photo12.webp";
import photo13 from "../assets/photo13.webp";
import photo14 from "../assets/photo14.webp";
import photo15 from "../assets/photo15.webp";
import photo17 from "../assets/photo17.webp";
import photo20 from "../assets/photo20.webp";
import photo21 from "../assets/photo21.webp";
import photo22 from "../assets/photo22.webp";
import photo23 from "../assets/photo23.webp";
import photo24 from "../assets/photo24.webp";
import photo25 from "../assets/photo25.webp";
import photo26 from "../assets/photo26.webp";
import photo27 from "../assets/photo27.webp";
import photo30 from "../assets/photo30.webp";
import photo31 from "../assets/photo31.webp";
import photo32 from "../assets/photo32.webp";
import photo33 from "../assets/photo33.webp";
import photo35 from "../assets/photo35.webp";
import photo37 from "../assets/photo37.webp";
import photo38 from "../assets/photo38.webp";
import photo39 from "../assets/photo39.webp";
import photo40 from "../assets/photo40.webp";

//Command: cwebp file.jpeg -o file.webp

export const images = [
  {
    src: photo1,
    alt: "On top of Empire State Bulding, New York",
    width: 921,
    height: 414,
  },
  {
    src: photo2,
    alt: "Time Square, New York",
    width: 921,
    height: 414,
  },
  {
    src: photo3,
    alt: "Newgale Beach, Pembrokshire, Wales",
    width: 921,
    height: 690,
  },
  {
    src: photo4,
    alt: "Blaen y Glyn Waterfalls, Brecon, Wales",
    width: 921,
    height: 690,
  },
  {
    src: photo5,
    alt: "Nash Point, Vale of Glamorgan, Wales",
    width: 921,
    height: 690,
  },
  {
    src: photo6,
    alt: "Roath Park, Cardiff, Wales",
    width: 921,
    height: 415,
  },
  {
    src: photo7,
    alt: "A Daffodil",
    width: 980,
    height: 600,
  },
  {
    src: photo8,
    alt: "Tree",
    width: 921,
    height: 518,
  },
  {
    src: photo9,
    alt: "plant",
    width: 921,
    height: 518,
  },
  {
    src: photo10,
    alt: "Trogir, Croatia",
    width: 480,
    height: 250,
  },
  {
    src: photo11,
    alt: "Trogir Castle, Croatia",
    width: 920,
    height: 500,
  },
  {
    src: photo12,
    alt: "Klis Fortress, Croatia",
    width: 920,
    height: 500,
  },
  {
    src: photo13,
    alt: "Split, Croatia",
    width: 480,
    height: 300,
  },
  {
    src: photo14,
    alt: "Seiser Alm, Italy",
    width: 800,
    height: 480,
  },
  {
    src: photo15,
    alt: "Cinque Torri, Italy",
    width: 480,
    height: 250,
  },
  {
    src: photo17,
    alt: "Venice, Italy",
    width: 800,
    height: 400,
  },
  {
    src: photo20,
    alt: "Torpantau, Brecon, Wales",
    width: 850,
    height: 580,
  },
  {
    src: photo21,
    alt: "Newgale Sunset, Wales",
    width: 920,
    height: 420,
  },
  {
    src: photo22,
    alt: "Lago di braies",
    width: 980,
    height: 480,
  },
  {
    src: photo23,
    alt: "Copenhagen Round Tower, Denmark",
    width: 880,
    height: 430,
  },
  {
    src: photo24,
    alt: "Black and White photo, Denmark",
    width: 620,
    height: 380,
  },
  {
    src: photo25,
    alt: "Black and White photo, Denmark",
    width: 720,
    height: 380,
  },
  {
    src: photo26,
    alt: "Amalienburg palace, Copenhagen, Denmark",
    width: 890,
    height: 480,
  },
  {
    src: photo27,
    alt: "Rosenborg Castle, Denmark",
    width: 680,
    height: 380,
  },
  {
    src: photo30,
    alt: "Malmo, Sweeden",
    width: 720,
    height: 360,
  },
  {
    src: photo31,
    alt: "Brynea, Wales",
    width: 720,
    height: 360,
  },
  {
    src: photo32,
    alt: "Bergen, Norway",
    width: 680,
    height: 320,
  },
  {
    src: photo33,
    alt: "Norway",
    width: 680,
    height: 320,
  },
  {
    src: photo35,
    alt: "France",
    width: 720,
    height: 320,
  },
  {
    src: photo37,
    alt: "Cwmcarn, Wales",
    width: 930,
    height: 620,
  },
  {
    src: photo38,
    alt: "Norway",
    width: 820,
    height: 320,
  },
  {
    src: photo39,
    alt: "Noway",
    width: 620,
    height: 320,
  },
  {
    src: photo40,
    alt: "Nyhavn, Copenhagen, Denmark",
    width: 620,
    height: 280,
  },
].sort(() => Math.random() - 0.5);
